export const isUserLoggedIn = () => {
  const token = sessionStorage.getItem("token");
  if (token) {
    // const decryptedData = decryptData(token);
    if (token) {
      return true;
    } else {
      return false;
    }
  }
};

export  const getMicrositeUrl = (partnerName) => {
  const baseUrl = process.env.REACT_APP_MICROSITE_BASE_URL;
  if (!baseUrl) return "";

  // Local / Dev → no subdomain
  if (baseUrl.includes("localhost") || baseUrl.includes("web.core.windows.net")) {
    return baseUrl.startsWith("http") ? baseUrl : `https://${baseUrl}`;
  }

  // Prod → dynamic subdomain
  // Convert partner name to URL-safe format
  const safePartner = partnerName.toLowerCase().replace(/\s+/g, "-");
  return `https://${safePartner}.${baseUrl}`;
};